import { Link, useLocation, useNavigate } from "react-router-dom";
import { Navbar } from "@/components/Navbar";

export default function DashboardShell({ nav = [], children }) {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6 grid lg:grid-cols-[220px_1fr] gap-6">
        <aside className="hidden lg:block">
          <nav className="space-y-1 sticky top-20">
            {nav.map((n) => {
              const active = location.pathname === n.to;
              return (
                <Link key={n.to} to={n.to} data-testid={n.testid}
                  className={`flex items-center gap-2.5 px-3 py-2 rounded-lg text-sm font-medium transition-colors ${active ? "bg-[#FFF3EC] text-[#C05615]" : "text-slate-600 hover:bg-white hover:text-slate-900"}`}>
                  <n.icon className="w-4 h-4" /> {n.label}
                </Link>
              );
            })}
          </nav>
        </aside>
        <div className="min-w-0">
          <div className="lg:hidden mb-4 -mx-4 px-4 overflow-x-auto">
            <div className="flex gap-2 w-max">
              {nav.map((n) => (
                <button key={n.to} onClick={() => navigate(n.to)} className={`text-xs whitespace-nowrap px-3 py-1.5 rounded-full border ${location.pathname === n.to ? "bg-[#D96B27] text-white border-[#D96B27]" : "bg-white text-slate-600 border-slate-200"}`}>{n.label}</button>
              ))}
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
